import type { IDElement } from "../IDElement";
import type { ReportConfiguration } from "./reportConfiguration";

export type ProbationConfiguration = ReportConfiguration & {
  data: {
    aspects: Aspect[];
    remarks: string;
  };
};

export type Aspect = IDElement & {
  title: string;
  description: string;
  graded: boolean;
};

export const emptyAspect: Omit<Aspect, "id"> = { title: "", graded: false, description: "" };
